import { Component, Output, Input, EventEmitter } from '@angular/core';

@Component({
  selector: 'dvl-info-dialog',
  templateUrl: './info-dialog.component.html'
})
export class DvlInfoDialogComponent {
  @Output('close') closeEmitter: EventEmitter<void>;
  @Output('save') saveEmitter: EventEmitter<string>;
  @Input() note: string;
  @Input() readonly: boolean;

  constructor() {
    this.closeEmitter = new EventEmitter<void>();
    this.saveEmitter = new EventEmitter<string>();
    this.note = '';
  }

  close(): void {
    this.closeEmitter.emit();
  }

  save(): void {
    this.saveEmitter.emit(this.note);
    this.close();
  }
}



// WEBPACK FOOTER //
// /Proyectos-Ankaa/proyecto-meriendas-diverland/src/app/info-dialog/info-dialog.component.ts